import { render, staticRenderFns } from "./FrameBasic.vue?vue&type=template&id=31e6d6d8&scoped=true&"
import script from "./FrameBasic.vue?vue&type=script&lang=js&"
export * from "./FrameBasic.vue?vue&type=script&lang=js&"
import style0 from "./FrameBasic.vue?vue&type=style&index=0&id=31e6d6d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e6d6d8",
  null
  
)

export default component.exports